import { mapActions, mapGetters } from "vuex";

import { snackBarEventBus, snackBarEventName } from "@/eventBuses/snackBar.eventBus";

export const archiveListMixin = {
  name: "AppointmentsArchive",
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapGetters(["role"]),
    ...mapGetters("encounters", ["encounters"]),
    archiveItems() {
      return this.encounters
        .filter((e) => ["finished", "cancelled", "triaged"].includes(e.status))
        .concat()
        .sort((a, b) => {
          return new Date(b.start) - new Date(a.start);
        });
    },
  },
  methods: {
    ...mapActions("encounters", ["getAllEncounters"]),
    async getListEncounters() {
      this.loading = true;
      try {
        await this.getAllEncounters();
      } catch (e) {
        snackBarEventBus.$emit(snackBarEventName, { message: e.message || e, type: "error" });
      }
      this.loading = false;
    },
    joinRoom(encounterId) {
      this.$router.push(`/${this.role}/encounters/${encounterId}`);
    },
  },
  async mounted() {
    await this.getListEncounters();
  },
};
